import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useCreateTask = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while creating task");

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (userData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(`${tenantVal}/task`, userData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    },
    onSuccess: (_, variables) => {
      toast.success(variables.id ? "Task edited successfully" : "New Task created successfully");
      queryClient.invalidateQueries({ queryKey: ["tasks"] });
      queryClient.invalidateQueries({ queryKey: ["homeTasks"] });
      queryClient.invalidateQueries({ queryKey: ["closedPaginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["paginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["sentPaginatedTasks"] });
      queryClient.invalidateQueries({ queryKey: ["prescriptionTasks"] });
      queryClient.invalidateQueries({ queryKey: ["patientTasks"] });
    },
    onError: handleNetworkError,
  });
};
